import React, { useEffect } from "react";
import "./home.css";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import ServiceCategory from "../../components/serviceCategory/ServiceCategory";
import GetStartedSection from "../../components/getStartedSection/GetStartedSection";
import { useLocation, useNavigate } from "react-router-dom";
import SEO from "../../components/SEO/SEO";

import FirstBanner from "../../components/firstBanner/FirstBanner";
import HomeAboutUs from "../../components/homeAboutUs/HomeAboutUs";
import HomeProjects from "../../components/homeProjects/HomeProjects";

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const searchBtnHome = () => {
    // localStorage.setItem("Search_Data", searchInput);
    navigate("/search_product");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return (
    <div>
      <SEO
        title="Home"
        description="Swadaa Security & Guards Limited offers professional security guards, surveillance, emergency response, and community empowerment services in Lagos and across Nigeria. Protect your assets with trusted local security expertise."
        keywords="Swadaa Security, security guards, private security services, Lagos security company, emergency response, surveillance, community safety, empowerment programs"
      />
      <Navbar />

      {/* <a
        aria-label="Chat on WhatsApp"
        href="https://api.whatsapp.com/send?phone=+2348033477608&text=I%20am%20reaching%20out%20to%20explore%20your%20business%20offering."
        target="_blank"
        className="whatsappStickbody"
      >
        <div className="whatsappStickActive"></div>
        <img src={ProductImg.whatsApp} />
      </a> */}
      <FirstBanner
        // headBtnText="Our Projects"
        headText="Swadaa Security and Guards Services"
        // headTextSpan="-SWADAA Express"
        headPara="Professional security services and community empowerment delivered with discipline, vigilance and trust."
      />
      <HomeAboutUs />
      <ServiceCategory />

      <HomeProjects />
      <GetStartedSection />
      <Footer />
    </div>
  );
};

export default Home;
